// 사용설명서 패널 — docs/manual.html을 iframe으로 표시
export function Manual() {
  return (
    <iframe
      src="/manual.html"
      title="사용설명서"
      style={{ width: '100%', height: 'calc(100vh - 60px)', border: 'none', display: 'block' }}
    />
  );
}
